import { Box, Image } from '@chakra-ui/react';
import type { BigNumber } from '@ethersproject/bignumber';
import { parseUnits } from '@ethersproject/units';
import Balance from '@ui/components/Balance';
import type { ClaimedVnoSimpleLineChartProps } from '@ui/components/ClaimedVnoSimpleLineChart';
import { ClaimedVnoSimpleLineChart } from '@ui/components/ClaimedVnoSimpleLineChart';
import { VenoInfoView } from '@ui/components/VenoInfoView';
import WithWallet from '@ui/components/Wallet/WithWallet';
import useVenoEarnings from '@ui/hooks/useVenoEarnings';
import { useVnoUsdValue } from '@ui/hooks/useVnoUsdValue';
import { useTranslations } from '@ui/i18n';
import getBgImage from '@ui/utils/getBgImageProps';
import { currentWallet } from '@veno-app/wallet';
import { useMemo } from 'react';

import HarvestAllActionCard from './HarvestAllActionCard';

const { useIsConnected } = currentWallet;

export const Vaults = () => {
  const t = useTranslations();

  const connected = useIsConnected();
  const bgImageProps = connected ? {} : getBgImage('PATTERN_2');

  const { currentData, historicalData } = useVenoEarnings('ALL');

  const totalClaimedVno: BigNumber | undefined =
    currentData !== undefined ? parseUnits(`${currentData}`, 18) : undefined;
  const { data: totalClaimedVnoUsd, isLoading: totalClaimedVnoUsdLoading } =
    useVnoUsdValue(totalClaimedVno);

  const claimedVnoList: ClaimedVnoSimpleLineChartProps['dataList'] = useMemo(
    () =>
      historicalData
        ? historicalData.map((d) => {
            return {
              claimedVno: d.valueBigNumber,
              date: d.date.getTime(),
            };
          })
        : [],
    [historicalData],
  );

  return (
    <Box
      my={6}
      bgPos="right -50px"
      minH="572px"
      px={{ base: 4, desktop: 0 }}
      {...bgImageProps}
    >
      <WithWallet connectHint={t('Connect wallet to see your dashboard')}>
        <Balance
          title={t('{coin} claimed', {
            coin: 'VNO',
          })}
          amount={totalClaimedVno}
          icon={<Image alt="vno" src="/tokens/vno.svg" />}
          usdAmount={totalClaimedVnoUsd}
          showUsdAmount={!totalClaimedVnoUsdLoading}
          usdDisplayDecimals={2}
        />
        {!!claimedVnoList?.length && (
          <ClaimedVnoSimpleLineChart dataList={claimedVnoList} mt="28px" />
        )}
        <HarvestAllActionCard mt="34px" />
        <Box mt="34px">
          <VenoInfoView />
        </Box>
      </WithWallet>
    </Box>
  );
};
